import { createEntity } from 'lib/resource';
import Schema from './schema';

export default createEntity(Schema);
